"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
const lit_html_1 = require("../lit-html/lit-html");
const legacyCustomElement = (tagName, clazz, options) => {
    window.customElements.define(tagName, clazz, options);
    return clazz;
};
const standardCustomElement = (tagName, descriptor, options) => {
    const { kind, elements } = descriptor;
    return {
        kind,
        elements,
        // This callback is called once the class is otherwise fully defined
        finisher(clazz) {
            window.customElements.define(tagName, clazz, options);
        }
    };
};
const isFunction = (v) => typeof v === 'function';
const customElement = (tag, config = {}) => (Base) => {
    var _a;
    if (!tag || (tag && tag.indexOf('-') <= 0)) {
        throw new Error(`You need at least 1 dash in the custom element name! ${Base}`);
    }
    config.styles = config.styles || [];
    const OnInit = Base.prototype.OnInit || function () { };
    const OnDestroy = Base.prototype.OnDestroy || function () { };
    const OnUpdate = Base.prototype.OnUpdate || function () { };
    const OnUpdateFirst = Base.prototype.OnUpdateFirst || function () { };
    const connectedCallback = Base.prototype.connectedCallback || function () { };
    const disconnectedCallback = Base.prototype.disconnectedCallback || function () { };
    const update = Base.prototype.update || function () { };
    const firstUpdated = Base.prototype.firstUpdated || function () { };
    let registry;
    if (!config.template) {
        config.template = Base.prototype.render || (() => (0, lit_html_1.html) ``);
    }
    if (config.style) {
        config.styles.push(config.style);
    }
    const ModifiedClass = (_a = class NoName extends Base {
            static is() {
                return tag;
            }
            getTemplateResult() {
                return this;
            }
            OnInit() {
                if (config.container) {
                    (0, lit_html_1.render)(config.template.call(this), config.container);
                    if (config.style) {
                        const style = document.createElement('style');
                        style.type = 'text/css';
                        if (style['styleSheet']) {
                            // This is required for IE8 and below.
                            style['styleSheet'].cssText = config.style.toString();
                        }
                        else {
                            style.appendChild(document.createTextNode(config.style.toString()));
                        }
                        config.container.prepend(style);
                    }
                }
                return OnInit.call(this);
            }
            disconnectedCallback() {
                OnDestroy.call(this);
                disconnectedCallback.call(this);
                registry === null || registry === void 0 ? void 0 : registry.unsubscribe();
                registry = null;
            }
            connectedCallback() {
                var _a, _b;
                connectedCallback.call(this);
                OnInit.call(this);
                if (isFunction(config.registry)) {
                    registry = config.registry.call(this);
                }
                if ((_a = config.modifiers) === null || _a === void 0 ? void 0 : _a.length) {
                    for (const modifier of config.modifiers) {
                        if (!modifier) {
                            throw new Error(`Provided null value inside modifiers for component "${config.selector}"`);
                        }
                        if (!modifier.options) {
                            throw new Error(`Missing options for attribute inside ${config.selector}`);
                        }
                        if (!((_b = modifier.options) === null || _b === void 0 ? void 0 : _b.selector)) {
                            throw new Error(`Missing attribute selector inside component "${config.selector}"`);
                        }
                        if (!registry && typeof modifier.options.registry === 'function') {
                            registry = modifier.options.registry.call(this);
                        }
                        if (!registry) {
                            throw new Error(`Missing attribute registry for attribute "${modifier.options.selector}" and no default registry specified inside component "${config.selector}"`);
                        }
                        registry.define(modifier.options.selector, modifier);
                    }
                }
            }
            render() {
                return config.template.call(this);
            }
            update() {
                update.call(this);
                OnUpdate.call(this);
            }
            firstUpdated() {
                firstUpdated.call(this);
                OnUpdateFirst.call(this);
            }
        },
        _a.styles = config.styles,
        _a);
    const registeredElement = window.customElements.get(tag);
    if (registeredElement) {
        console.error(`** IMPORTANT!!! **
              ------------------------------------------
< ${tag} > </${tag}> Component re-defined multiple times and it is already registered inside customElements registry
Possible Solutions:
* Bundle problem where multiple versions of the component are used
            * @Component decorator is used twice for the same component
              * Defined "selector" with the same name in multiple components

                ** If this is Server Side Rendering you can ignore this message **
                  ------------------------------------------
                    `);
        return registeredElement;
    }
    if (typeof ModifiedClass === 'function') {
        legacyCustomElement(tag, ModifiedClass, {
            extends: config.extends
        });
    }
    else {
        standardCustomElement(tag, ModifiedClass, { extends: config.extends });
    }
    return ModifiedClass;
};
const Component = (config) => customElement(config.selector, config);
exports.Component = Component;
